import React from 'react';
import CopyableField from './CopyableField';
import NoteDisplay from './NoteDisplay';

const DocumentCard = ({ document, onEdit, onDelete }) => {
  return (
    <article className="w-full min-w-0 bg-white border border-gray-300 rounded-lg p-3 flex flex-col gap-2">
      <header className="flex items-center justify-between gap-2">
        <h2 className="font-bold text-gray-900 text-md leading-tight truncate min-w-0 flex-1">
          {document.title}
        </h2>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onEdit(document)}
            title="Edit"
            aria-label="Edit"
          >
            <i className="fa-solid fa-pen" />
          </button>
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onDelete(document)}
            title="Delete"
            aria-label="Delete"
          >
            <i className="fa-solid fa-trash" />
          </button>
        </div>
      </header>

      <CopyableField value={document.value} />

      <NoteDisplay value={document.note} />
    </article>
  );
};

export default DocumentCard;
